import { createAction } from '@reduxjs/toolkit';

import { SET_RECAPTCHA_VISIBLE, type RecaptchaVisible } from './types';

export const setRecaptchaVisible = createAction<RecaptchaVisible, typeof SET_RECAPTCHA_VISIBLE>(
	SET_RECAPTCHA_VISIBLE,
);
